
import { publicRoutes } from './publicRoutes';
import { privateRoutes } from './privateRoutes';
import SidebarLayout from 'src/layouts/SidebarLayout';
import BaseLayout from 'src/layouts/BaseLayout';
import Status404 from 'src/authentications/Status404';
import ProtectedRoute from './protectedRoute';

const RoutingHandler = [
  {
    path: '',
    element: <BaseLayout />,
    children: [ ...publicRoutes ],
  },
  {
    path: '/',
    element: (
      <ProtectedRoute>
        <SidebarLayout />
      </ProtectedRoute>
    ),
    children: [...privateRoutes],
  },
  {
    path: '*',
    element: <Status404 />,
  },
];

export default RoutingHandler;
